"use client"

/**
 * IntercomComponent - Landing page Intercom integration
 *
 * For landing pages (anonymous visitors):
 * - Loads Intercom lazily: after the visitor's first tap/scroll/key press (at the next quiet
 *   moment), or 20 s after the page's load event for visitors who never interact. Keeps its
 *   ~470 KB of script out of page load (and out of Lighthouse/PageSpeed) and away from taps.
 *   Clicking the facade button still loads and opens it at once.
 * - On /setup: no automatic load and no automatic opening (SETUP_PATH in IntercomProvider).
 * - Shows facade button until loaded
 * - No user identification
 *
 * For authenticated app pages, use IntercomProvider in the app layout
 * with user data for proper identification.
 */

import { usePathname } from "next/navigation"
import { IntercomProvider, IntercomFacade } from "@/components/intercom"
import { SETUP_PATH } from "@/components/intercom/IntercomProvider"

export default function IntercomComponent() {
    const onSetup = SETUP_PATH.test(usePathname() ?? "")
    return (
        <IntercomProvider
            loadOnIdle={!onSetup}
            blockAutoOpen={onSetup}
            idleTimeout={8000}
            deferAfterLoadMs={20000}
            loadOnFirstInteraction={true}
            hideDefaultLauncher={false}
        >
            <IntercomFacade />
        </IntercomProvider>
    )
}
